import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { CloneObject } from '../../../utils/helpers';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { TRIBUTO_TYPE, useForm } from '@laramie/ui';
import { DatePickerCustom, InputEntidad, FormLabel, FormError } from '../../common';
import { isNull } from '../../../utils/validator';
import Modal from '../../common/Modal';
import { TIPS } from "../../../consts/tips";
const IncisoVehiculoEmisionDefinicionModal = (props) => {

  const entityInit = {
    idIncisoVehiculo: 0,
    idEmisionDefinicion: 0,
    fechaDesde: null,
    fechaHasta: null
  };

  const [state, setState] = useState({
    entity: entityInit
  });

  const mount = () => {
    setState(prevState => {
      return { ...prevState, entity: props.data.entity };
    });
    formSet({
      idEmisionDefinicion: props.data.entity.idEmisionDefinicion,
      fechaDesde: props.data.entity.fechaDesde,
      fechaHasta: props.data.entity.fechaHasta
    });
  }
  useEffect(mount, [props.data.entity]);

  const [formValues, formHandle, , formSet] = useForm({
    idEmisionDefinicion: 0,
    fechaDesde: null,
    fechaHasta: null
  });

  const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

  const handleClickAceptar = () => {
    if (validate()) {
      let row = CloneObject(state.entity);
      row.idEmisionDefinicion = formValues.idEmisionDefinicion;
      row.fechaDesde = formValues.fechaDesde;
      row.fechaHasta = formValues.fechaHasta;
      props.onConfirm(row);
    }
  };

  function getErrors() {
    const errors = {};

    if (!isNull(formValues.fechaDesde) && !isNull(formValues.fechaHasta) && formValues.fechaDesde > formValues.fechaHasta) errors.fechaHasta = 'No puede ser anterior a la fecha desde';
    if (formValues.idEmisionDefinicion <= 0) errors.idEmisionDefinicion = VALIDATION_MESSAGE.REQUIRED_OPTION;

    return errors;
  }

  function getFormatErrors() {
    const errors = {};

    if (esRangoSolapado()) errors.fechaDesde = 'El rango se superpone con otro';

    return errors;
  }

  function esRangoSolapado() {
    const rango = props.rangoSolapado;
    return !isNull(rango)
        && sonLaMismaFecha(rango.fechaDesde, formValues.fechaDesde)
        && sonLaMismaFecha(rango.fechaHasta, formValues.fechaHasta);
  }

  function sonLaMismaFecha(una, otra) {
    if (isNull(una) || isNull(otra)) return isNull(una) && isNull(otra);
    return una.getTime() === otra.getTime();
  }

  return (
    <>
      <Modal
        size="lg"
        title="Inciso vehículo - Definición de emisión"
        tipName={TIPS.NAME.MODALS.INCISO_VEHICULO_EMISION_DEFINICION_MODAL}
        onEscape={() => props.onDismiss()}
        body={(
              <div className="row">

                <div className="mb-3 col-6">
                  <label htmlFor="idIncisoVehiculo" className="form-label">Inciso vehículo</label>
                  <InputEntidad
                    name="idIncisoVehiculo"
                    title="Inciso vehículo"
                    placeholder=""
                    className="form-control"
                    value={state.entity.idIncisoVehiculo}
                    disabled={true}
                    entidad="IncisoVehiculo"
                    onFormat={(row) => (row && row.id) ? `${row.codigo} - ${row.nombre}` : ''}
                    columns={[
                      { Header: 'Código', accessor: 'codigo', width: '20%' },
                      { Header: 'Nombre', accessor: 'nombre', width: '80%' },
                    ]}
                    memo={false}
                  />
                </div>

                <div className="mb-3 col-6">
                  <FormLabel htmlFor="idEmisionDefinicion" required>Definición de emisión</FormLabel>
                  <InputEntidad
                    name="idEmisionDefinicion"
                    title="Definición de emisión"
                    tipName={TIPS.NAME.MODALS.EMISION_DEFINICION_MODAL}
                    placeholder=""
                    className={`form-control ${errorOf('idEmisionDefinicion') ? 'is-invalid' : ''}`}
                    value={formValues.idEmisionDefinicion}
                    onChange={formHandle}
                    disabled={props.disabled}
                    entidad="EmisionDefinicion"
                    onFormat={(row) => (row && row.id) ? `${row.numero} - ${row.descripcion}` : ''}
                    filter={(row) => row.idTipoTributo === TRIBUTO_TYPE.VEHICULOS && row.calculoMostradorWeb}
                    columns={[
                      { Header: 'Número', accessor: 'numero', width: '20%' },
                      { Header: 'Descripción', accessor: 'descripcion', width: '80%' },
                    ]}
                    memo={false}
                  />
                <FormError message={errorOf('idEmisionDefinicion')} />
                </div>

                <div className="mb-3 col-3">
                  <label htmlFor="fechaDesde" className="form-label">Fecha desde</label>
                  <DatePickerCustom
                    name="fechaDesde"
                    placeholder=""
                    className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                    value={formValues.fechaDesde}
                    onChange={formHandle}
                    disabled={props.disabled}
                  />
                <FormError message={errorOf('fechaDesde')} />
                </div>
                <div className="mb-3 col-3">
                  <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                  <DatePickerCustom
                    name="fechaHasta"
                    placeholder=""
                    className={`form-control ${errorOf('fechaHasta') ? 'is-invalid' : ''}`}
                    value={formValues.fechaHasta}
                    onChange={formHandle}
                    disabled={props.disabled}
                    minValue={formValues.fechaDesde}
                  />
                <FormError message={errorOf('fechaHasta')} />
                </div>

              </div>
        )}
        footer={!props.disabled ? (<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => props.onDismiss()}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={() => handleClickAceptar()}>Aceptar</button>
        </>) : (
                <button className="btn back-button" data-dismiss="modal" onClick={() => props.onDismiss()}>Volver</button>
        )}
        footerClassName={props.disabled ? 'f-align' : ''}
      />
    </>
  );
}

IncisoVehiculoEmisionDefinicionModal.propTypes = {
  disabled: bool,
  data: object.isRequired,
  rangoSolapado: object,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

IncisoVehiculoEmisionDefinicionModal.defaultProps = {
  disabled: false,
  rangoSolapado: null
};

export default IncisoVehiculoEmisionDefinicionModal;
